import React from 'react';
import Navbar from '../components/Navbar';
import './Locations.css';
import mumbaiMap from '../assets/mumbai_map.jpg';
import { FaMapMarkerAlt, FaDirections } from 'react-icons/fa';

const Locations = () => {
  const branches = [
    {
      name: "BORIVALI WEST",
      address: "Shop No. 1, Ground Floor, Shree Sai Darshan Building, Opposite Kora Kendra Ground, S.V. Road, Borivali West, Mumbai - 400092",
      contact: "+91 91363-82299",
    },
    {
      name: "HEAD OFFICE - MIRA ROAD EAST (KANAKIA ROAD)",
      address: "1st Floor, Dev Paradise, Next To Lotus Hospital, Above Pizzeria, Kanakia Road, Mira Road East, Thane - 401107",
      contact: "+91 72088 88695",
    },
    {
      name: "MIRA ROAD EAST (SHRISHTI COMPLEX)",
      address: "Shop no 7,8 & 10, Poonam Cluster 2, Opposite Balajee Hotel, Shrishti road, Mira Road, Maharashtra 401107.",
      contact: "+91 91363-82299",
    },
    {
      name: "BHAYANDAR WEST",
      address: "Shop no. 4 and 5, Janki Orchid, Opposite S.L.Porwal High School, 90ft road, Bhayandar (west), Thane: 401 101.",
      contact: "+91 72088-88694",
    },
    {
      name: "KANDIVALI WEST (MAHAVIR NAGAR)",
      address: "Shop No. F-57, Xth Central Mall, opposite Axis Bank, Kandivali, Mahavir Nagar, Kandivali West, Mumbai, Maharashtra 400067.",
      contact: "+91 8779601390",
    },
    {
      name: "GOREGOAN EAST (GOKULDHAM)",
      address: "Shop No. - G-2, Gokuldham Shopping Centre, Near Gokuldham High School, Goregaon (East), Mumbai – 400063",
      contact: "+91 7977536385",
    },
    {
      name: "THANE WEST (HIRANANDANI ESTATE)",
      address: "4th floor, Shop No 412, Arcadia Shopping Centre, Hiranandani Estate, Thane West, Thane – 400607",
      contact: "+91 91363 19824",
    },
    {
      name: "GOREGAON WEST",
      address: "Corporate Corner, Mandlik Nagar, Sunder Nagar, Malad West, Mumbai, Maharashtra 400064",
      contact: "+91 91363-82299",
    },
    {
      name: "DAHISAR EAST",
      address: "Ground Floor A1/3, RASHTRIYA MAZDOOR ANAND NAGAR UNIT NO 1, BLDG NO 1 & 2 CO OP HSG SOC, SHIVAJI ROAD, ANAND NAGAR, DAHISAR EAST, MUMBAI-400068",
      contact: "+91 91363-82299",
    }
  ];

  return (
    <div className="locations-bg">
      <Navbar />
      <div className="locations-title-centered">
        <h1 className="locations-title">OUR BRANCHES & LOCATIONS</h1>
      </div>
      <div className="locations-flex-container">
        <div className="locations-map-col-img">
          <img src={mumbaiMap} alt="Mumbai Map" className="mumbai-map-img polished-map-img" />
        </div>
        <div className="locations-list-col">
          <div className="locations-list-beautiful-container">
            {branches.map((branch, index) => (
              <div key={index} className="location-item-simple polished-location-item">
                <h3>{branch.name}</h3>
                <p className="luxury-branch-address"><FaMapMarkerAlt className="address-icon" /> {branch.address}</p>
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(branch.address)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="directions-button"
                >
                  <FaDirections style={{ marginRight: 8, verticalAlign: 'middle' }} /> Get Directions
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Locations; 